import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function AvaLighting({ ios }) {
    // =====================================================
    // AVA_IPAD_NO_SPECULAR_LIGHT_DOTS_V9A2
    //
    // The raw iPad renderer keeps Ava's original glossy
    // central lens. Multiple positional/directional lights
    // can produce several circular specular highlights.
    //
    // On iPad only, use non-positional ambient illumination.
    // Desktop / non-iPad lighting remains exactly unchanged.
    // =====================================================
    if (ios) {
        // AVA_IPAD_BRIGHTNESS_V9A4
        //
        // Stronger diffuse illumination without restoring the
        // positional/direct front lights that created lens dots.
        return (_jsxs(_Fragment, { children: [_jsx("ambientLight", { intensity: 1.48 }), _jsx("hemisphereLight", { skyColor: "#f4fbff", groundColor: "#6c7d91", intensity: 0.72 })] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx("ambientLight", { intensity: ios ? 0.82 : 1.05 }), _jsx("directionalLight", { position: [1.8, 2.6, 3.4], intensity: ios ? 1.00 : 1.55, color: "#dff8ff" }), _jsx("directionalLight", { position: [-2.5, 1.3, 1.8], intensity: ios ? 0.40 : 0.72, color: "#8fdfff" }), _jsx("directionalLight", { position: [0.0, 2.8, -3.5], intensity: ios ? 0.55 : 0.95, color: "#78d8ff" }), _jsx("pointLight", { position: [0, -0.9, 1.4], intensity: ios ? 0.20 : 0.35, distance: 4, color: "#d9fbff" })] }));
}
